import React from 'react';
import { StyledTitle } from './HeaderStyling';

const Header = () => {
  return (
    <StyledTitle>Todo List</StyledTitle>
  )
};

export default Header;